// Store link (`<slug>.adyvance.com`, D-015) rules shared by the API (validateStoreSlug, which also
// checks the reserved list and uniqueness) and the admin onboarding form (live hint before submit).

/** Platform apex for store subdomains (D-015). The API reads PLATFORM_APEX_DOMAIN; this is the
 *  display value for forms. */
export const STORE_APEX_DOMAIN = "adyvance.com";

/** Staging shops live at `<slug>-dev.<apex>` (D-080; the API reads STORE_HOST_SUFFIX). No shop
 *  slug may end in it, so a live shop can never take a staging shop's address. */
export const STAGING_HOST_SUFFIX = "-dev";

/** The suffix the admin shows after the slug: "-dev" when the admin itself runs on staging. */
export function storeHostSuffixFor(adminHost: string): string {
  return adminHost === `application.${STORE_APEX_DOMAIN}` ? STAGING_HOST_SUFFIX : "";
}

export const STORE_SLUG_MIN = 3;
export const STORE_SLUG_MAX = 63;

/** 3–63 lowercase letters, digits or single hyphens; no leading or trailing hyphen (DNS label). */
export function isValidStoreSlug(slug: string): boolean {
  return /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])$/.test(slug) && !slug.includes("--");
}

/**
 * A link suggestion from a business name: Latin letters and digits only, joined by hyphens.
 * Returns "" when nothing usable remains (for example an all-Devanagari name); the form then asks
 * the vendor to type the link. Never transliterates (merchant names stay exactly as typed).
 */
export function suggestStoreSlug(name: string): string {
  const s = name
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, STORE_SLUG_MAX)
    .replace(/-+$/, "");
  return isValidStoreSlug(s) ? s : "";
}
